import React from "react";
import { Grid, Input, TextField } from "@material-ui/core";
import AddIcon from '@material-ui/icons/Add';
import { InstyleButton, InstyleFloatingSaveButton } from '../../components/Page/Page';
import RuleItem from "./RuleItem";
import { useSelector } from 'react-redux';
import { getAllAreas } from "../../store/slices/salesAreaSlice";
import { getAllSources } from "../../store/slices/leadSourceSlice";
import { campaignService } from "../../services/campaigns.service";
import InstyleSwitch from "../Switch/InstyleSwitch";

function NewCampaign(props) {
    let newCampaign = props.Campaign || {
        ID: null,
        Name: "New Campaign",
        Active: true,
        Rules: [],
        Priority: props.CampaignLength + 1 || 0
    };
    const [campaign, setCampaign] = React.useState(newCampaign)
    const salesAreas = useSelector(getAllAreas);
    const leadSources = useSelector(getAllSources);

    const nameChange = (event) => {
        setCampaign({...campaign, Name: event.target.value})
    }

    const addRule = () => {
        let rule = {
            CampaignID: campaign.ID,
            TypeID: 0,
            Values: [],
        }
        setCampaign({...campaign, Rules: [...campaign.Rules, rule]})
    }

    const ruleChanged = (index, rule) => {
        console.log(`Rule at index ${index} change to ${JSON.stringify(rule)}`)
        let updatedRules = [];
        campaign.Rules.forEach((r, ix) => {
          if (ix === index) {
            updatedRules[ix] = rule;
          }
          else {
            updatedRules[ix] = r;
          }
        });
        setCampaign({...campaign, Rules: updatedRules})
    }

    const removeRule = (index) => {
        setCampaign({...campaign, Rules: campaign.Rules.filter((r, i) => i !== index)});
    }

    const changeActive = (e) => {
        setCampaign({...campaign, Active: e})
    }

    const saveChanges = () => {
        let isError = false;
        let errorMessage = [];
        if (campaign.Rules.length === 0) {
            isError = true;
            errorMessage.push(`At least 1 rule is required.`);
        }
        //do some basic validation on things and reject anything that are OBVIOUSLY wrong
        campaign.Rules.forEach((r, ix) => {
            if (r.TypeID === 0 || r.Values.length == 0) {
                isError = true;
                errorMessage.push(`Rule at index ${ix+1} has an invalid type or no values.`)
            }
        })
        if (isError) {
            alert(errorMessage.join('\n'))
            return
        }

        campaignService.saveCampaign(campaign).then(resp => {
            //tell the parent to refresh campaigns
            console.log("save complete")
            if (props.onSaveHandler) {
                props.onSaveHandler();
            }
        });
    }

    return (
        <Grid container style={{maxWidth: "85%", backgroundColor: "white", height: "100%", maxHeight: "85%", alignContent: "flex-start"}}>
            <Grid item xs={12}>
                <span style={{textAlign: "center", display:"block", fontSize: "2em", margin: "1em"}}>Create a new Campaign</span>
            </Grid>
            <Grid item xs={12}>
                <Grid container style={{margin: "1em"}}>
                    <Grid item xs={6}>
                        {/* Campaign name */}
                        <TextField style={{width: "320px"}} id={"campaignName"} label="Campaign Name" onChange={nameChange} value={campaign.Name} />
                    </Grid>
                    <Grid item xs={6}>
                        {/* Active Toggle */}
                        <InstyleSwitch LeftLabel={'Not Active'} RightLabel={'Active'} checked={campaign.Active} onToggle={changeActive} />
                    </Grid>
                    <Grid item xs={12}>
                        <div style={{marginTop: "25px", fontSize: "1.5em"}}>Rules</div>
                    </Grid>
                    <Grid item xs={12}>
                        <div style={{marginTop: "25px", marginBottom: "25px"}}>
                            {/* loop over current rules and display here
                            add a button underneath to add more rules */}
                            {
                                campaign.Rules.map((rule, ix) => {
                                    return (
                                        <RuleItem
                                            key={`rule-${ix}`}
                                            onRuleRemove={removeRule}
                                            onRuleChange={ruleChanged}
                                            index={ix}
                                            ruleTypes={props.ruleTypes}
                                            Rule={rule}
                                            salesAreas={salesAreas}
                                            leadSources={leadSources}
                                        />
                                    )
                                })
                            }
                        </div>
                    </Grid>
                    <InstyleButton style={{marginTop: "20px"}} onClick={addRule}><AddIcon /></InstyleButton>
                    <InstyleFloatingSaveButton onClick={saveChanges}>Save</InstyleFloatingSaveButton>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default NewCampaign;
